import { GlobalEvents, WidgetVisibility } from '@enums';

export function CreateElement(tag: string, props = {}) {
  return Object.assign(document.createElement(tag), props);
}

export function toggleGlobalModal(isVisible: boolean = true) {
  window.postMessage({ type: GlobalEvents.ToggleModal, isVisible: isVisible }, window.location.origin);
}

export function getWidgetLocation() {
  const path = window.location.pathname;

  const isHomePage = path === '/';
  const isCollectionPage = path.includes('collections');
  const isContactPage = path.includes('contact');
  const isCartPage = path.includes('cart');
  const isCustomPage = path.includes('/pages');
  const isProductPage = !!document.querySelector('form[action="/cart/add"]');

  let isBlogListingPage = false;
  let isBlogArticlePage = false;
  if (path.includes('/blogs')) {
    const segments = path.split('/').filter(Boolean);
    if (segments.length === 2) {
      isBlogListingPage = true;
    } else if (segments.length >= 3) {
      isBlogArticlePage = true;
    }
  }

  if (isHomePage) {
    return 'home-page';
  } else if (isCollectionPage) {
    return 'collections-page';
  } else if (isProductPage) {
    return 'product-page';
  } else if (isCartPage) {
    return 'cart-page';
  } else if (isContactPage) {
    return 'contact-page';
  } else if (isBlogArticlePage) {
    return 'blog-article-page';
  } else if (isBlogListingPage) {
    return 'blog-listing-page';
  } else if (isCustomPage) {
    return 'custom-page';
  }

  return 'unknown';
}

export function getCookie(name: string) {
  const regex = new RegExp(`(^| )${name}*=([^;]+)`);
  const match = RegExp(regex).exec(document.cookie);
  if (match) {
    return match[2];
  }
}

export const stringTokenReplacer = (phrase: string, tokenKeyValues: { [key: string]: string }) => {
  for (let x in tokenKeyValues) {
    const token = `{${x}}`;
    phrase = phrase?.replace(token, tokenKeyValues[x]);
  }
  return phrase;
}

export const isWidgetHidden = (visibility: WidgetVisibility) => {
  const widgetLocation = getWidgetLocation();
  // visibility is not global and the current page does not match what the visibility is set to
  return visibility && visibility !== WidgetVisibility.Global && !widgetLocation.includes(visibility || null);
}

export const deepMergeObjects = <T extends Record<string, any>>  (target: T, source: Partial<T>): T => {
  for (const key in source) {
    const sourceValue = source[key];
    const targetValue = target[key];

    const isObject = (val: any): val is Record<string, any> =>
      val && typeof val === 'object' && !Array.isArray(val);

    if (isObject(sourceValue) && isObject(targetValue)) {
      target[key] = deepMergeObjects(
        { ...targetValue },
        sourceValue
      );
    } else {
      target[key] = sourceValue as T[typeof key];
    }
  }
  return target;
}

export const monitorDuplicateWidgets = async (widgetElement: string, widgetType: string, location: string, storeName: string = "Unknown", sideCart = false) => {
  const widgets = Array.from(document.querySelectorAll(widgetElement))
  .filter(el => 
    sideCart ? el.hasAttribute('cartDrawer') : !el.hasAttribute('cartDrawer') &&
    el.shadowRoot && el.shadowRoot.children.length > 0
  ).length;

  const alreadyTrackedEvent = sessionStorage.getItem(`${widgetElement}${sideCart ? '-cart-drawer' : ''}-${location}`);

  if((widgets > 1) && !alreadyTrackedEvent){
    const mixpanel = (window as any).inspiredMixpanel;
    mixpanel?.track('multiple_widgets_detected', {
      storeName: storeName,
      widgetType: widgetType,
      widgetLocation: location ?? 'unknown',
      widgetCount: widgets
    });

    sessionStorage.setItem(`${widgetElement}${sideCart ? '-cart-drawer' : ''}-${location}`, "true");
  }
}
